import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl, { FormControlProps } from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MuiSelect, {
  SelectChangeEvent,
  SelectProps,
} from '@mui/material/Select';

export type Props = {
  ariaLabel?: string;
  disabled?: boolean;
  value: string;
  label?: string;
  multiple?: boolean;
  options: {
    value: string;
    content: React.ReactNode;
  }[];
  onChange(value: string): void;
  onBlur?(): void;
  placeholder?: string;
  color?: 'primary';
  size?: SelectProps['size'];
  formControl?: FormControlProps;
  helperText?: React.ReactNode;
  MenuProps?: Partial<MenuProps>;
};

export default function Select({
  ariaLabel,
  disabled,
  options,
  onChange,
  value = '',
  color,
  formControl,
  helperText,
  ...others
}: Props) {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl fullWidth variant='outlined' {...formControl}>
      {!!others.label && <InputLabel>{others.label}</InputLabel>}
      <MuiSelect
        aria-label={ariaLabel}
        disabled={disabled}
        onChange={handleChange}
        value={value}
        {...others}
      >
        {others.placeholder && (
          <MenuItem disabled value=''>
            <em>{others.placeholder}</em>
          </MenuItem>
        )}
        {options.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.content}
          </MenuItem>
        ))}
      </MuiSelect>
      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
